import axios from "@/libs/api.request";

export const getLotteryAwardList = filterCond => {
  return axios.request({
    url: "lottery/getLotteryAwardList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};
export const saveLotteryAwardData = data => {
  return axios.request({
    url: "lottery/saveLotteryAwardData",
    data: data,
    csrf: true,
    method: "post"
  });
};

export const getLotteryHistory = filterCond => {
  return axios.request({
    url: "lottery/getLotteryHistory",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};
